// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Antd = require("antd");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

var _map = {"button":"button","checkobx":"checkobx","color":"color","date":"date","datetimeLocal":"datetime-local","email":"email","file":"file","hidden":"hidden","image":"image","month":"month","number":"number","password":"password","radio":"radio","range":"range","reset":"reset","search":"search","submit":"submit","tel":"tel","text":"text","time":"time","url":"url","week":"week"};

var _revMap = {"button":"button","checkobx":"checkobx","color":"color","date":"date","datetime-local":"datetimeLocal","email":"email","file":"file","hidden":"hidden","image":"image","month":"month","number":"number","password":"password","radio":"radio","range":"range","reset":"reset","search":"search","submit":"submit","tel":"tel","text":"text","time":"time","url":"url","week":"week"};

function inputTypeToJs(param) {
  return _map[param];
}

function inputTypeFromJs(param) {
  return _revMap[param];
}

var Internal = {};

function Antd_Input(Props) {
  var autoFocus = Props.autoFocus;
  var placeholder = Props.placeholder;
  var addonAfter = Props.addonAfter;
  var addonBefore = Props.addonBefore;
  var defaultValue = Props.defaultValue;
  var disabled = Props.disabled;
  var id = Props.id;
  var prefix = Props.prefix;
  var size = Props.size;
  var suffix = Props.suffix;
  var value = Props.value;
  var onChange = Props.onChange;
  var onFocus = Props.onFocus;
  var onPressEnter = Props.onPressEnter;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onDoubleClick = Props.onDoubleClick;
  var onKeyDown = Props.onKeyDown;
  var _type = Props.type;
  var readOnly = Props.readOnly;
  var autoComplete = Props.autoComplete;
  var allowClear = Props.allowClear;
  var status = Props.status;
  var className = Props.className;
  var style = Props.style;
  var children = Props.children;
  var tmp = {
    children: children !== undefined ? Caml_option.valFromOption(children) : null
  };
  if (autoFocus !== undefined) {
    tmp.autoFocus = autoFocus;
  }
  if (placeholder !== undefined) {
    tmp.placeholder = placeholder;
  }
  if (addonAfter !== undefined) {
    tmp.addonAfter = Caml_option.valFromOption(addonAfter);
  }
  if (addonBefore !== undefined) {
    tmp.addonBefore = Caml_option.valFromOption(addonBefore);
  }
  if (defaultValue !== undefined) {
    tmp.defaultValue = defaultValue;
  }
  if (disabled !== undefined) {
    tmp.disabled = disabled;
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (prefix !== undefined) {
    tmp.prefix = Caml_option.valFromOption(prefix);
  }
  if (size !== undefined) {
    tmp.size = Caml_option.valFromOption(size);
  }
  if (suffix !== undefined) {
    tmp.suffix = Caml_option.valFromOption(suffix);
  }
  if (value !== undefined) {
    tmp.value = value;
  }
  if (onChange !== undefined) {
    tmp.onChange = Caml_option.valFromOption(onChange);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (onPressEnter !== undefined) {
    tmp.onPressEnter = Caml_option.valFromOption(onPressEnter);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (onDoubleClick !== undefined) {
    tmp.onDoubleClick = Caml_option.valFromOption(onDoubleClick);
  }
  if (onKeyDown !== undefined) {
    tmp.onKeyDown = Caml_option.valFromOption(onKeyDown);
  }
  var tmp$1 = Belt_Option.map(_type, inputTypeToJs);
  if (tmp$1 !== undefined) {
    tmp.type = tmp$1;
  }
  if (readOnly !== undefined) {
    tmp.readOnly = readOnly;
  }
  if (autoComplete !== undefined) {
    tmp.autoComplete = autoComplete;
  }
  if (allowClear !== undefined) {
    tmp.allowClear = allowClear;
  }
  if (status !== undefined) {
    tmp.status = Caml_option.valFromOption(status);
  }
  if (className !== undefined) {
    tmp.className = className;
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement(Antd.Input, tmp);
}

function bool(v) {
  return v;
}

function minAndMaxRows(v) {
  return v;
}

var AutoSize = {
  bool: bool,
  minAndMaxRows: minAndMaxRows
};

var TextArea = {
  AutoSize: AutoSize
};

var Search = {};

var Group = {};

var Password = {};

var make = Antd_Input;

exports.inputTypeToJs = inputTypeToJs;
exports.inputTypeFromJs = inputTypeFromJs;
exports.Internal = Internal;
exports.make = make;
exports.TextArea = TextArea;
exports.Search = Search;
exports.Group = Group;
exports.Password = Password;
/* antd Not a pure module */
